<template>
  <BaseTabs
    v-model="tabValue"
    :tabs="tabs"
    tabs-class="<sm:wd-sticky <sm:wd-top-16 <sm:wd-bg-white <sm:wd-z-1"
    tab-class="wd-text-omd wd-py-3 !wd-min-w-min <sm:wd-flex-1"
  />
</template>

<script lang="ts" setup>
import BaseTabs, { type Tab } from '@/components/common/BaseTabs.vue'

interface Props {
  tabs: Tab[]
}

defineOptions({ name: 'MemberTabs' })

const props = defineProps<Props>()

const tabValue = defineModel<string>({ required: false })
</script>
